import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { __, sprintf } from '@wordpress/i18n';
import { getPaymentMethodData } from '@woocommerce/settings';


import './qrmodal.scss';

const SwishQRModal = ({ isOpen, onClose, qrCodeData, swishToken, swishLink, billing }) => {
    if (!isOpen) return null;
    const settings = getPaymentMethodData( 'redlight_swish-ecommerce', {} );
    const billingData = billing.billingData;
    const start_on_this_device = __('Start Swish on this device', 'woocommerce-gateway-swish-ecommerce');
    const qr_instructions = __('We are currently awaiting your payment, please proceed to scan the QR-code below and finalize your payment.', 'woocommerce-gateway-swish-ecommerce' );
    const instructions = sprintf( __('We are currently awaiting your payment, please proceed to open your Swish-app connected to <strong>%s</strong> and finalize your payment.', 'woocommerce-gateway-swish-ecommerce'), billingData.phone );

    return createPortal(
        <div className="swish-qr-modal">
            <div className="swish-qr-modal-content">
                <div className="swish-qr-modal-content-wrap">
                    {/* Swish logo */}
                    <div className="swish_logo symbol rotate">
                        <img src={settings.symbol_logo}/>
                    </div>
                    <div className="swish_logo">
                        <img src={settings.text_logo}/>
                    </div>

                    {/* Instructions */}
                    {!qrCodeData &&
                        <p className='instructions' dangerouslySetInnerHTML={{ __html: instructions }}></p>
                    }

                    {/* QR Instructions */}
                    {qrCodeData &&
                        <p className='instructions'>{qr_instructions}</p>
                    }
                    {/* Swish QR Code */}
                    {qrCodeData &&
                        <>
                            <a style={{display: "contents"}} href={swishLink} target="_blank">
                                <div className="redlight-swish-mcommerce-qr-code" dangerouslySetInnerHTML={{ __html: qrCodeData }}></div>
                            </a>
                        </>
                    }
                    {/* Open Swish on this Device */}
                    {swishToken &&
                    <div className="swish-button">
                        <a className="openSwish" id="startswish" href={swishLink} target="_blank">{start_on_this_device}</a>
                    </div>
                    }
                    {/* Instructions - How to scan */}
                    {qrCodeData &&
                        <p className='scan-instructions'>
                            <img srcSet={settings.instructions_img+"@1.5x.png 1.5x,"+settings.instructions_img+"@2x.png 2x"} src={settings.instructions_img+".png"} alt="Swish QR Instructions"/>
                        </p>
                    }
                </div>
            </div>
        </div>,
        document.body
    );
};
export default SwishQRModal;